import Cookies from "js-cookie";

export const setSession = (accessToken: string, tokenType: string) => {
    Cookies.set("accessToken", accessToken);
    Cookies.set("tokenType", tokenType);
}

export const getSession = () => {
    return {
        accessToken: Cookies.get("accessToken"),
        tokenType: Cookies.get("tokenType"),
    }
}

export type User = {
    id: string;
    email: string;
    isVerified: boolean;
    isActive: boolean;
    isSuperAdmin: boolean;
}

export const setUser = (user: User) => {
    Cookies.set("user", JSON.stringify(user));
}

export const getUser = () => {
    const user = Cookies.get("user");
    if (!user) {
        return null;
    }
    return JSON.parse(user);
}

export const clearSession = () => {
    Cookies.remove("accessToken");
    Cookies.remove("tokenType");
    Cookies.remove("user");
    localStorage.clear();
}
